import React, { Dispatch, SetStateAction, useEffect } from "react";
import { Col, Divider, Form, Input, message, Modal, Row } from "antd";
import Button from "../../Button";
import apis from "../../../services/apiCrypto";
import { useAuth } from "../../../contexts/AuthContext";
import { useSideBar } from "../../../contexts/SideBarContext";
import bitcoinTradeLogo from "../../../assets/bitcointrade-logo.svg";
import { validationFieldRequired } from "../../../utils/formValidations";
import bitcoinTradeLogoWhite from "../../../assets/bitcointrade-logo-white.svg";
import { IntegrationData } from "../interfaces";
import EmbedCollapse from "../EmbedCollapse";

interface IBitcoinTradeIntegrationModalProps {
  visible: boolean;
  setVisible: Dispatch<SetStateAction<boolean>>;
  setLoadingIntegration: Dispatch<SetStateAction<boolean>>;
  integrationData?: IntegrationData;
}

const BitcoinTradeIntegrationModal: React.FC<
  IBitcoinTradeIntegrationModalProps
> = ({ visible, setVisible, setLoadingIntegration, integrationData }) => {
  const { user } = useAuth();
  const [form] = Form.useForm();
  const { dark } = useSideBar();

  useEffect(() => {
    if (integrationData && visible) {
      form.setFieldsValue({ key: integrationData.key });
    }
  }, [form, integrationData, visible]);

  const onCancel = () => {
    setVisible(false);
    form.resetFields();
  };

  const onFinish = (values: any) => {
    setVisible(false);
    setLoadingIntegration(true);
    apis
      .post("/bitcoin-trade/integrate", values, {
        params: { email: user.user.email },
      })
      .catch((err) => {
        if (err.response?.data?.message) {
          message.error(
            err.response?.data?.message ||
              "Algo deu errado, tente novamente mais tarde"
          );
        }
        setLoadingIntegration(false);
      });
  };

  return (
    <Modal
      footer={null}
      destroyOnClose
      visible={visible}
      onCancel={onCancel}
      maskClosable={false}
      title={
        <span style={{ display: "flex", alignItems: "center" }}>
          <img
            src={dark ? bitcoinTradeLogoWhite : bitcoinTradeLogo}
            alt="Binance logo"
            style={{ height: "32px", marginRight: "16px" }}
          />
          Integrar com a BitcoinTrade
        </span>
      }
    >
      <Form
        form={form}
        layout="vertical"
        onReset={onCancel}
        onFinish={onFinish}
      >
        <EmbedCollapse embedId="YjQ1aS1gEjA" />
        <Form.Item name="key" rules={validationFieldRequired}>
          <Input placeholder="Key (Chave)" size="large" />
        </Form.Item>
        <Divider />
        <Row justify="space-between">
          <Col>
            <Form.Item>
              <Button size="large" htmlType="reset">
                Cancelar
              </Button>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item>
              <Button size="large" htmlType="submit" type="primary">
                Integrar
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default BitcoinTradeIntegrationModal;
